import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "riwayatPendidikan";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const masterEducation = "Master/Education/list/";
export const masterRumpun = "Master/Rumpun/daftar_rumpun/";
export const masterEmployee = "Master/GajiWeb/listPegawai/";

export const riwayatPendidikanCreate = "Kepegawaian/RiwayatPendidikan/create/";
export const riwayatPendidikanList = "Kepegawaian/RiwayatPendidikan/list/";
export const riwayatPendidikanDetail = "Kepegawaian/RiwayatPendidikan/detail/";
export const riwayatPendidikanUpdate = "Kepegawaian/RiwayatPendidikan/update/";
export const riwayatPendidikanInactive =
  "Kepegawaian/RiwayatPendidikan/inactive/";
export const riwayatPendidikanActive = "Kepegawaian/RiwayatPendidikan/active/";
export const riwayatPendidikanApprove =
  "Kepegawaian/RiwayatPendidikan/approve/";
export const ListJabatan = "Kepegawaian/RiwayatPendidikan/listjabatan/";

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
